// Component: TopicPanel
// Author: Mito Are
import React from 'react';
import { Text, Image, Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import TopicPanel from '@component/TopicPanel';
import { useHashFragment } from '../../useHashFragment';

const TopicPanelComponent = (props) => {
  const themeObject = props.params.Theme === undefined ? '' : JSON.parse(props.params.Theme);
  const themeColor = themeObject?.Color === undefined ? '' : themeObject?.Color.value;
  useHashFragment();
  return (
    <>
      <TopicPanel
        PanelId={props.fields?.panelid?.value}
        variant={themeColor}
        TopicPanelTitle={<Text field={props.fields?.paneltitle} />}
        TopicPanelBody={<Text field={props.fields?.panelsubtitle} />}
        TopicPanelList={<Placeholder name="topic-panel-card" rendering={props.rendering} />}
      />
    </>
  );
};
export default withSitecoreContext()(TopicPanelComponent);
